<template>
  <div>
    <div class="emp-header">
      <heading class="mb-0">
        {{ $t("sidebar.employees") }}
      </heading>
      <employeeOverview section="metrics" class="emp-header__overview" />
    </div>

    <!-- tabs on the left, role tags + workplace switch on the right -->
    <div class="emp-tabsbar">
      <v-tabs v-model="currentPath" class="emp-tabsbar__tabs">
        <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact>
          {{ headers(tab.id) }}
        </v-tab>
      </v-tabs>
      <employeeOverview section="tags" class="emp-tabsbar__overview" />
    </div>

    <router-view />
  </div>
</template>

<script>
import employeeOverview from "@/views/employee/employeeOverview.vue";

export default {
  components: { employeeOverview },
  data() {
    return {
      currentPath: "", // <- v-tabs v-model target
      tabs: [
        {
          id: 1,
          route: "/app/employee/employeeTable",
        },
        {
          id: 3,
          route: "/app/employee/employeeExternalTable",
        },
        {
          id: 2,
          route: "/app/employee/employeeArchiveTable",
        },
      ],
    };
  },

  watch: {
    // keep currentPath in sync with the current route
    $route: {
      immediate: true,
      handler(route) {
        this.currentPath = route.path;
      },
    },
  },

  methods: {
    headers(i) {
      switch (i) {
        case 1:
          return this.$t("employee.tabs.employee");
        case 3:
          return this.$t("employee.tabs.external");
        default:
          return this.$t("employee.tabs.archive");
      }
    },
  },
};
</script>

<style scoped>
/* Row 1: page title + metric strip, vertically centred together. */
.emp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 24px;
}
.emp-header__overview {
  margin-left: auto;
}

/* Row 2: tabs on the left, role tags + workplace switch on the right. */
.emp-tabsbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 24px;
}
.emp-tabsbar__tabs {
  width: auto;
  flex: 0 1 auto;
}
.emp-tabsbar__overview {
  margin-left: auto;
}
</style>
